import React from 'react';
import ScaleIcon from '../../icons/IconLib/ScaleIcon';
import { IPrintersItem } from '../../../modules/API/Defaults/models/printers';
import SearchableSelect from '../SearchableSelect/SearchableSelect';

interface Props {
    scales: IPrintersItem[];
    value: IPrintersItem | null;
    onSelect: (scale: IPrintersItem | null) => void;
    placeholder?: string;
    disabled?: boolean;
    readOnly?: boolean;
    className?: string;
}

const ScalesSelector: React.FC<Props> = ({
    scales,
    value,
    onSelect,
    placeholder = 'בחר משקל',
    disabled,
    readOnly,
    className,
}) => (
    <SearchableSelect<IPrintersItem>
        items={scales}
        value={value}
        onSelect={onSelect}
        getKey={(s) => s.NumWeight}
        getLabel={(s) => (s.DescWeights ?? '').trim()}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        leadingIcon={<ScaleIcon />}
        className={className}
        emptyLabel='אין משקלים מתאימים'
    />
);

export default ScalesSelector;
